import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import {
  ListItemButton
} from "@biome-design-system/ui/ListItemButton";
import { DefaultQuestionStepAnswer } from "./DefaultQuestionStepAnswer.js";
const Answer = styled(ListItemButton, {
  name: "MuiFilterWizard",
  slot: "answer"
})(() => ({}));
const FilterWizardQuestionStepAnswerInner = ({
  answer,
  children,
  labels,
  onClick,
  ...restProps
}, ref) => {
  if (children) {
    return /* @__PURE__ */ jsx(
      Answer,
      {
        ...restProps,
        ref,
        children
      }
    );
  }
  if (answer) {
    return /* @__PURE__ */ jsx(
      DefaultQuestionStepAnswer,
      {
        ...restProps,
        answer,
        labels,
        onClick,
        ref
      }
    );
  }
  return null;
};
const FilterWizardQuestionStepAnswer = forwardRef(
  FilterWizardQuestionStepAnswerInner
);
export {
  FilterWizardQuestionStepAnswer
};
